import React, { useMemo } from 'react';

/**
 * Componente que renderiza un diamante de béisbol con bases activas
 * @param {Object} props - Propiedades del componente
 * @param {string} props.sport - Tipo de deporte ('BASE')
 * @param {boolean} props.islive - Indica si el juego está en vivo
 * @param {Object} props.baseball_data - Datos del juego de béisbol
 * @param {boolean} props.baseball_data.onBase1 - Jugador en primera base
 * @param {boolean} props.baseball_data.onBase2 - Jugador en segunda base
 * @param {boolean} props.baseball_data.onBase3 - Jugador en tercera base
 * @param {number} props.baseball_data.outs - Número de outs
 */
export default function BaseballDiamond({ sport, islive, baseball_data }) {
  // Memoizar configuración de bases para evitar recálculos
  const basesConfig = useMemo(() => {
    if (!baseball_data) return [];
    return [
      { key: 'first', active: baseball_data.onBase1, className: 'base first' },
      { key: 'second', active: baseball_data.onBase2, className: 'base second' },
      { key: 'third', active: baseball_data.onBase3, className: 'base third' }
    ];
  }, [baseball_data]);

  // Memoizar texto de outs para evitar recálculos
  const outsText = useMemo(() => {
    if (!baseball_data) return '0 outs';
    const outs = baseball_data.outs || 0;
    return `${outs} out${outs !== 1 ? 's' : ''}`;
  }, [baseball_data]);
  
  // Validaciones después de los hooks
  if (sport !== 'BASE' || !islive || !baseball_data) {
    return null;
  }

  return (
    <div className='container-diamond'>
      <div className="baseball-diamond">
        {basesConfig.map(({ key, active, className }) => (
          <div 
            key={key}
            className={active ? `${className} active` : className}
            aria-label={`${key} base ${active ? 'occupied' : 'empty'}`}
          />
        ))}
      </div>
      <div className='title-diamond' aria-live="polite">
        {outsText}
      </div>
    </div>
  );
}